import {Key} from 'react';

import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

import {IGetDataArgs} from '../model/types';
import {
    ISubmitGroupCompanyResponse,
    IPostISubmitGroupCompany,
    ISubmitGroupCompanyDto,
    ISendCroupCompanyService,
} from './types';

const SUBMIT_GROUP_COMPANY_URL = 'integration.module/organization-structure/company.group.change';

const getData = (args?: IGetDataArgs) =>
    performRequest<ISubmitGroupCompanyResponse>({
        url: SUBMIT_GROUP_COMPANY_URL,
        method: ERequestType.GET,
        params: {
            paginationPageSize: args?.paginationPageSize,
            paginationCurrent: args?.paginationCurrent,
        },
    });

const getDataById = (id: number) =>
    performRequest<ISubmitGroupCompanyDto>({
        url: `${SUBMIT_GROUP_COMPANY_URL}/${id}`,
        method: ERequestType.GET,
    });

const postData = (args: IPostISubmitGroupCompany) =>
    performRequest<string>({
        url: SUBMIT_GROUP_COMPANY_URL,
        data: args,
        method: ERequestType.POST,
    });

const putData = (args: ISubmitGroupCompanyDto) =>
    performRequest<string>({
        url: `${SUBMIT_GROUP_COMPANY_URL}/${args.id}`,
        data: args,
        method: ERequestType.PUT,
    });

const deleteData = (args: {rowsIds: Key[]}) =>
    performRequest<string>({
        url: `${SUBMIT_GROUP_COMPANY_URL}/delete-list`,
        data: {ids: args.rowsIds},
        method: ERequestType.DELETE,
    });


const sendService = (args: ISendCroupCompanyService) => {
    const formData = new FormData();
    
    formData.append('externalServiceId', String(args.externalServiceId));
    formData.append('reportingDate', args.date);
    formData.append('companyCode', String(args.code));
    
    return performRequest<string>({
        url: `/integration.module/monitor.services/execute`,
        data: formData,
        method: ERequestType.POST,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const submitGroupCompanyApi = {getData, getDataById, postData, putData, deleteData, sendService};
